import { render, staticRenderFns } from "./gateway.vue?vue&type=template&id=77cc6d54&scoped=true&"
import script from "./gateway.vue?vue&type=script&lang=js&"
export * from "./gateway.vue?vue&type=script&lang=js&"
import style0 from "./gateway.vue?vue&type=style&index=0&id=77cc6d54&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77cc6d54",
  null
  
)

export default component.exports